import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as Rx from 'rxjs';
import { getRecursiveRouteData } from './page-view-tracking.helpers';
import { Tracking } from './tracking.service';

@Component({
  selector: 'fl-page-view-tracking',
  template: ` <ng-container></ng-container> `,
})
export class PageViewTrackingComponent implements OnInit, OnDestroy {
  private trackPageViewSubscription?: Rx.Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private tracking: Tracking,
    private router: Router,
  ) {}

  ngOnInit() {
    this.trackPageViewSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.tracking.trackPageView(
          getRecursiveRouteData(this.activatedRoute.snapshot).is404,
        );
      }
    });
  }

  ngOnDestroy() {
    this.trackPageViewSubscription?.unsubscribe();
  }
}
